export default "__VITE_ASSET__sldNSqlC__"